import React, { useContext } from 'react';
import filter from 'lodash/filter';
import { StyledText } from './SelectProviders.style';
import { loginProvidersToHandlers } from './SelectProviders.service';
import { OAuthProviders, ProviderBoxesView } from '@linearb/linui-common';
import { LoginContext } from '../../../root/views/dashboard/context/LoginContext';

const gitStreamSupportedProviders = [
  // { name: 'bitbucket', enabled: false },
  // { name: 'gitlab', enabled: true },
  { name: 'github', enabled: true }
];

const gitStreamSupportedProvidersNames = gitStreamSupportedProviders.map(
  ({ name }) => name
);

const filteredProviders = filter(OAuthProviders, (_, provider) =>
  gitStreamSupportedProvidersNames.includes(provider)
);

const providers = filteredProviders.reduce((acc, value) => {
  acc[value.title] = {
    ...value,
    enabled: gitStreamSupportedProviders.find(
      ({ name }) => name === value.title
    ).enabled
  };
  return acc;
}, {});

export const SelectProvider = ({ onLoginStart }) => {
  const { gdprConsentGiven } = useContext(LoginContext);

  function onProviderClick(config) {
    onLoginStart();
    const handler = loginProvidersToHandlers[config.authIdentity];
    handler?.();
  }

  return (
    <>
      <StyledText>Select your Git provider to sign in</StyledText>
      <ProviderBoxesView
        data-cy='login-provider'
        providers={providers}
        onProviderClick={onProviderClick}
        lastLoggedInProviderName='github'
        disabled={!gdprConsentGiven}
      />
    </>
  );
};
